import { useAuthContext } from '../hooks';

export function useHasBuyerOrg() {
  const { user } = useAuthContext();
  const { buyerOrg, buyerSite } = user || {};
  const hasBuyerOrg = !!user?.buyerOrg;
  return { hasBuyerOrg, buyerOrg, buyerSite };
}
